<template>
    <div>
        <b-input-group size="sm" :prepend="text" :append="append" class="mb-1">
            <b-form-input
                :value="value"
                @input="$emit('input', $event)"
                :disabled="disabled"
                :type="type"
            ></b-form-input>
        </b-input-group>
    </div>
</template>

<script>
    export default {
        props: ['text', 'append', 'value', 'type', 'disabled']
    }
</script>

<style scoped>
</style>